import { createContext } from "react";
import { IContextTicket } from "../types/ticket.interface";

const TicketScreen = createContext<IContextTicket>({});

export default TicketScreen;
